<template>
  <div id="preview-base">
    <div id="preview-box">
      <div id="display-box">
        <img id="logo" :src="question.sponsor_logo" />
        <div id="question">{{ question.question }}</div>
        <div v-if="question.options.length < 5" id="options">
          <div
            v-for="(item, index) in question.options"
            :key="index"
            :id="'option-' + index"
          >
            {{ item.option }}
            <div>
              <div class="option-base">
                <div class="option-bar">
                  <div
                    class="filler"
                    :style="{
                      width: Math.floor(2.72 * getPercentage()) + 'px',
                      backgroundColor: '#' + question.brand_color
                    }"
                  ></div>
                </div>
              </div>
              <div class="percent">{{ getPercentage() }}</div>
              <div class="percent-sign">%</div>
            </div>
          </div>
        </div>
        <div v-else id="options">
          <div v-for="index in 3" :key="index" :id="'option-' + (index - 1)">
            {{ question.options[index - 1].option }}
            <div>
              <div class="option-base">
                <div class="option-bar">
                  <div
                    class="filler"
                    :style="{
                      width: Math.floor(2.72 * getPercentage()) + 'px',
                      backgroundColor: '#' + question.brand_color
                    }"
                  ></div>
                </div>
              </div>
              <div class="percent">{{ getPercentage() }}</div>
              <div class="percent-sign">%</div>
            </div>
          </div>
          <div id="'option-extra">
            Teised valikud
            <div>
              <div class="option-base">
                <div class="option-bar">
                  <div
                    class="filler"
                    :style="{
                      width: Math.floor(2.72 * getPercentage()) + 'px',
                      backgroundColor: '#' + question.brand_color
                    }"
                  ></div>
                </div>
              </div>
              <div class="percent">{{ getPercentage() }}</div>
              <div class="percent-sign">%</div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer" :style="{ backgroundColor: '#' + question.brand_color }">
        <div id="banner">Hääleta.ee</div>
        <div id="call-to-action">Tule ja anna oma hääl</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "livePreview",
  props: {
    question: {
      default: null
    }
  },
  helpers: {
    percentageLeft: 100,
    percentages: [],
    currentPercentageRequestCounter: 0
  },
  methods: {
    getPercentage() {
      this.$options.helpers.currentPercentageRequestCounter++;

      if (this.$options.helpers.currentPercentageRequestCounter === 1) {
        this.$options.helpers.percentageLeft = 100;
        this.$options.helpers.percentages = [];
      }

      if (
        this.$options.helpers.currentPercentageRequestCounter > 6 ||
        this.question.options.length * 2 - 1 <=
          this.$options.helpers.currentPercentageRequestCounter
      ) {
        this.$options.helpers.currentPercentageRequestCounter =
          this.$options.helpers.currentPercentageRequestCounter %
          Math.min(8, this.question.options.length * 2);
        return this.$options.helpers.percentageLeft;
      }

      let currentQuestionIndex = Math.ceil(
        this.$options.helpers.currentPercentageRequestCounter / 2
      );

      if (!this.$options.helpers.percentages[currentQuestionIndex]) {
        let optionsLeft = this.question.options.length - currentQuestionIndex;

        let percentage =
          Math.floor(
            Math.random() * (this.$options.helpers.percentageLeft - optionsLeft)
          ) + 1;

        this.$options.helpers.percentageLeft =
          this.$options.helpers.percentageLeft - percentage;

        this.$options.helpers.percentages[currentQuestionIndex] = percentage;
      }

      return this.$options.helpers.percentages[currentQuestionIndex];
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Montserrat:400,800&display=swap");

#preview-base {
  font-family: "Montserrat", sans-serif;
}

#preview-box {
  width: 400px;
  margin: 0 auto;
  border: 1px solid #4eef31;
  position: relative;
}

#display-box {
  width: 100%;
  background-color: #ffffff;
  text-align: center;
  padding-left: 22px;
  padding-right: 22px;
  border-radius: 12px;
  z-index: 2;
  box-shadow: rgb(60, 60, 60) 0 4px 6px -3px;
  position: relative;
}

#footer {
  width: 100%;
  height: 89px;
  z-index: 1;
  border-radius: 0 0 12px 12px;
  position: relative;
  margin-top: -9px;
  padding-top: 9px;
}

#question {
  font-size: 22px;
  color: #080707;
  font-weight: 800;
  text-transform: uppercase;
  line-height: 1.2;
  text-align: center;
  margin-bottom: 7px;
}

#options {
  font-size: 18px;
  color: #080707;
  font-weight: 800;
  text-transform: uppercase;
  line-height: 1.2;
  text-align: left;
}

.option-base {
  width: 272px;
  height: 25px;
  display: inline-block;
}

.option-bar {
  background-color: #08070754;
  width: 272px;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
}

.filler {
  width: 0;
  height: 100%;
  border-radius: 12px;
}

.percent {
  font-size: 36px;
  color: #080707;
  font-weight: 800;
  text-transform: uppercase;
  line-height: 1.2;
  text-align: left;
  display: inline-block;
  width: 50px;
  margin-left: 3px;
}

.percent-sign {
  font-size: 24px;
  color: #080707;
  font-weight: 800;
  line-height: 1.2;
  text-align: left;
  display: inline-block;
  margin-left: 6px;
}

#banner {
  font-size: 45px;
  color: #ffffff;
  font-weight: 800;
  line-height: 1.2;
  text-align: center;
}

#call-to-action {
  font-size: 18px;
  color: #ffffff;
  line-height: 1.2;
  text-align: center;
}

#logo {
  margin-top: 10px;
  margin-bottom: 4px;
  /*background-color: #797979;*/
  max-height: 80px;
  width: auto;
}
</style>
